 export const getters = {
    incident: state => {
        return state.incident;
    },

    responsibles: state => {
        return state.responsibles;
    },

    components: state => {
        return state.components;
    },

    incidenttypes: state => {
        return state.incidenttypes;
    },

    forwardings: state => {
        return state.forwardings;
    },

    stepdatahistory: state => {
        return state.stepdatahistory;
    },

     stepdoctypes: state => {
        return state.stepdoctypes;
     },

    manufacturer: state => {
        return state.manufacturer;
    },

     inc: state => {
         return state;
     },

     clipboard: state => {
         return state.clipboard;
     },

     todo: state => {
         return state.todo;
     },
}